<div class="login-box" *ngIf="!loggedIn">
  <div class="form">
    <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm)">
        <img [src]="logo" class="logo mx-auto d-block mb-3">

        <div *ngIf="!isCloud" class="input-group mb-2">
            <span class="input-group-text"><i class="fa fa-user"></i></span>
            <input class="form-control" type="text" placeholder="Brugernavn" formControlName="username">
        </div>

        <div *ngIf="!isCloud" class="input-group mb-2">
            <span class="input-group-text">
                <i class="fa fa-key"></i>
            </span>
            <input class="form-control" type="password" placeholder="Password" formControlName="password">
        </div>

        <div class="d-grid">
            <button [disabled]="signingIn" type="submit" class="btn btn-lg btn-primary"><div *ngIf="signingIn" class="loader float-end"></div> Login </button>
        </div>
        <div *ngIf="loginError" class="alert alert-danger mt-3">
            {{loginError}}
        </div>
        <div *ngIf="isCloud" class="d-grid mt-3">
            <button [disabled]="signingIn" class="btn btn-lg btn-primary" (click)="onLogout()">Logout</button>
        </div>

    </form>
  </div>
</div>
